import { CustomOccPrice } from './price.model';

export interface OccProductConditionModel {
  conditions: OccProductCondition[];
}

export enum BonusTypes {
  PROMO_BONUS = 'PROMO_BONUS',
}

export interface OccProductCondition {
  unitCode: string;
  badgeTypes: BonusTypes[];
  bonusAmountInfo?: {
    value: number;
    formattedValue: string;
  };
  personalPrice?: CustomOccPrice;
}

export type ProductCondition = OccProductCondition;
